import { GEOAPIFY_CONFIDENCE_THRESHOLD } from '../core/constants'

const APP_GEOAPIFY_API_KEY = window.ENV.APP_GEOAPIFY_API_KEY

export const geoapifyAPI = {
  validateAddress,
  findAddresses
}

function validateAddress (searchString, alertSvc) {
  if (!APP_GEOAPIFY_API_KEY) return Promise.resolve(new Error('API key not set'))

  return sendApiRequest({ searchString, type: 'search' })
    .then(features => features[0]?.properties?.rank?.confidence)
    .then(confidence => {
      if (!confidence || confidence < GEOAPIFY_CONFIDENCE_THRESHOLD) {
        alertSvc && alertSvc.alert('Address not recognized - please make sure it is entered correctly.', 'danger')
        return Promise.reject(new Error('Address not recognized'))
      }
      return confidence
    })
}

function findAddresses (search, { countryCode, filter, params }) {
  if (!APP_GEOAPIFY_API_KEY) return Promise.reject(new Error('API key not set'))

  let searchString = params || ''
  searchString += search ? `&text=${search}` : ''
  searchString += filter ? `&type=${filter}` : ''
  searchString += countryCode ? `&filter=countrycode:${countryCode?.toLowerCase()}` : ''

  return sendApiRequest({ searchString, limit: 5, type: 'autocomplete' })
  // .then(features => features?.map(feature => feature.properties))
    .then(features => features.filter(f => f.properties[filter]))
}

function sendApiRequest (config) {
  const limit = config.limit || 1
  const searchString = config.searchString || ''
  const type = config.type || 'search'
  /* istanbul ignore if */
  if (!APP_GEOAPIFY_API_KEY) return Promise.reject(new Error('API key not set'))

  return window.fetch(`https://api.geoapify.com/v1/geocode/${type}?apiKey=${APP_GEOAPIFY_API_KEY}&limit=${limit}` + searchString, { method: 'GET' })
    .then(response => response.json())
    .then(result => result?.features)
    .catch(error => { console.log('error', error) })
}
